import reducer from './reducer'

import * as loanIncreasesOperations from './operations'
import * as loanIncreasesSelectors from './selectors'

export { loanIncreasesOperations, loanIncreasesSelectors }

export default reducer